import { render } from "./Supporters.vue?vue&type=template&id=a8890c52&scoped=true"
import script from "./Supporters.vue?vue&type=script&lang=js"
export * from "./Supporters.vue?vue&type=script&lang=js"

import "./Supporters.vue?vue&type=style&index=0&id=a8890c52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8890c52"]])

export default __exports__